import { useEffect } from "react";
import { X } from "lucide-react";

interface ModalProps {
  isOpen: boolean;
  title?: string;
  subtitle?: string;
  onClose?: () => void;
  children: React.ReactNode;
  className?: string;
}

const Modal = ({
  isOpen,
  title,
  subtitle,
  onClose,
  children,
  className = "",
}: ModalProps) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && onClose) onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className={`bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto ${className}`}
      >
        {title && (
          <div className="bg-gradient-to-r from-primary-700 to-primary-800 px-6 py-4 rounded-t-xl flex items-center justify-between">
            <div>
              <h2 className="text-lg font-bold text-white">{title}</h2>
              {subtitle && (
                <p className="text-primary-100 text-sm mt-0.5">{subtitle}</p>
              )}
            </div>
            {onClose && (
              <button
                onClick={onClose}
                className="p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
              >
                <X size={18} />
              </button>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
